import { render, staticRenderFns } from "./ReplacementInfo.vue?vue&type=template&id=52d748e0"
import script from "./ReplacementInfo.vue?vue&type=script&lang=js"
export * from "./ReplacementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports